export const Props = Symbol('Props')
export const StylesStoreSymbol = Symbol('StylesStore')
export const Structure = Symbol('Structure')
export const Comps = Symbol('Comps')
export const CompActionsSym = Symbol('CompActions')
export const StructureAPI = Symbol('StructureAPI')
